import { render } from "./InquiryReference.vue?vue&type=template&id=47f9c0c2&scoped=true&ts=true"
import script from "./InquiryReference.vue?vue&type=script&lang=ts"
export * from "./InquiryReference.vue?vue&type=script&lang=ts"

import "./InquiryReference.vue?vue&type=style&index=0&id=47f9c0c2&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47f9c0c2"]])

export default __exports__